import { BaseEntity } from '@core/entities/_extra';
import { NotificationsActionTypes, NotificationType } from '@core/enums';
import { Expose, Transform } from 'class-transformer';

export class NotificationEntity extends BaseEntity {
  @Expose()
  firstName: string;

  @Expose()
  lastName: string;

  @Expose()
  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  title: string;

  @Expose()
  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  text: string;

  @Expose()
  section: NotificationType;

  @Expose()
  notificationType: NotificationsActionTypes;

  @Expose()
  override userId: number;

  constructor(init?: Partial<NotificationEntity>) {
    super();
    this.initEntity(init);
  }
}
